var historyBackJS = {
    data() {

    },
    methods: {

    },
    mounted() {
        let that = this;
        window.onpopstate = function() {
            that.goBack(true)
        }
        window.history.pushState('forward', null, document.URL); 
        window.history.forward(1);
    },
    destroyed(){ 
        window.onpopstate = null;
    }
}

export default historyBackJS = historyBackJS


// WEBPACK FOOTER //
// ./src/components/common/historyBack.js